module.exports = __webpack_public_path__ + "img/XMO.1d045b58.svg";